import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { AccountantPouchAdminDto } from '@/backend/market'
import { AccountantPouchEntity } from '../../domain/entities/AccountantPouchEntity'

export class AccountantPouchModel extends AccountantPouchEntity {
  constructor(dataDto: AccountantPouchAdminDto) {
    super()
    mapEntityProperties<AccountantPouchModel>(this, dataDto)
  }
}
